export const fragTint = `
precision mediump float;

uniform vec3 uTintColour;

void main ()
{

  // "'gl_Color' : undeclared identifier", apparently "GLSL ES does not have a gl_Color"... ??

  float normTint = 0.30 * uTintColour.r + 0.59 * uTintColour.g + 0.11 * uTintColour.b;
  vec3  mixColor = uTintColour * gl_Color.rgb / normTint;
  gl_FragColor = vec4( mixColor.rgb, gl_Color.a );
}
`;
